<template>
  <v-layout row wrap white pt-3>
    <v-flex xs4 ml-4>
      <v-text-field
        v-model="name"
        label="Grupos de documentos"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      code: ""
    };
  },
  props: {
    searchDcumentsGroups: Function
  },
  methods: {
    search() {
      this.searchDcumentsGroups({ name: this.name });
    }
  }
};
</script>

<style>
</style>